module.exports = __webpack_public_path__ + "static/img/全球司库管理云2.0001cc04.png";